import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CampaignRoutingService {
  private readonly cancelToEditClickedEvent = new BehaviorSubject<any>(null);

  public emitCancelToEditEvent(campaignRecourseId: string, recourseCampaignExId: string): void {
    this.cancelToEditClickedEvent.next({ campaignRecourseId, recourseCampaignExId });
  }

  public cancelToEditEventListener(): Observable<any> {
    return this.cancelToEditClickedEvent.asObservable();
  }
}
